import { useAuth as useAuthContext } from '../contexts/AuthContext';

export const useAuth = () => {
  const context = useAuthContext();

  const adminRoles = ['super_admin', 'admin_user', 'admin_staff', 'admin_super'];
  const isAdmin = adminRoles.includes(context.user?.role);

  return {
    user: context.user,
    login: context.login,
    logout: context.logout,
    isAuthenticated: !!context.user,
    isAdmin,
    loading: context.loading,
    token: context.token
  };
};
